export const WorkingInterview = {
  APPEND: 'WORKING_INTERVIEW_APPEND',
  CREATE: 'WORKING_INTERVIEW_CREATE',
  DELETE: 'WORKING_INTERVIEW_DELETE',
  EDIT: 'WORKING_INTERVIEW_EDIT',
  CLEAR: 'WORKING_INTERVIEW_CLEAR',
};
